"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryParamsService = void 0;
class QueryParamsService {
    setQueryParamsAndString(params) {
        const eventParams = {};
        Object.keys(params).forEach((x) => {
            if (params[x] === undefined || params[x] === null || params[x] === '') {
                return;
            }
            eventParams[x] = params[x];
        });
        const query = new URLSearchParams(eventParams);
        return {
            query: query.toString(),
            params,
        };
    }
}
exports.QueryParamsService = QueryParamsService;
